module.exports = __webpack_public_path__ + "static/media/img.c463cf9d.png";